import { gql } from "@apollo/client";

export const Users_Query = gql`      
query getUsersForAccount($roleId: Int!, $filterByName: String, $joiningDateFilter:Date!, $pagingCriteria: PagingCriteria) {
    getUsersForAccount(roleId: $roleId, filterByName: $filterByName, joiningDateFilter: $joiningDateFilter  pagingCriteria: $pagingCriteria) {
        data {
            id
            name
            fullname
            debug
            profilePicture
            designation
            employeeId
            title
            role
            roleId
            ppm
            gender
            genderId
            userCharacter
            
            joiningDate
            numberOfAssociates
            numberOfManagers
        }
        pageMeta {
            nextPage
            previousPage
            hasNextPage
            hasPreviousPage
            totalCount
        }
    }
}`;

export const currentUserProfileQuery = gql`
  query ReadCurrentUserProfile{
    currentUserProfile {
      id
      name
      surname 
      designation
      email
      password
      phoneNumber
      roleId
    profilePicture
    role
    }
  }
`;



export const User_Form_Query = gql`
    mutation addUser($accountId: Int!,$currentRoleId:Int!, $employeeId: String!,  $firstName: String!,$lastName: String!, 
      $gender: String!,$dateOfBirth:Date!, $email: String!, $higestEducationQualification: String!,$previousEmployer:String!,$previousExperience: String!,
       $phoneNumber: String!, $employementType: String!, $joiningDate: Date!,  $designation: Int!, $branch: String!, $zone: String!, $city: String!, $state: String!, $managerEmployeeId: String!, $validFrom: String!){
         addUser(accountId:$accountId, currentRoleId: $currentRoleId, employeeId: $employeeId, firstName: $firstName, lastName: $lastName,
          gender: $gender, dateOfBirth: $dateOfBirth, email: $email, higestEducationQualification: $higestEducationQualification,previousEmployer: $previousEmployer,
          phoneNumber: $phoneNumber, employementType: $employementType, joiningDate: $joiningDate, designation: $designation, branch: $branch,
          zone: $zone, city: $city, state: $state, managerEmployeeId: $managerEmployeeId, validFrom: $validFrom) {
          data {
            id
            
          }
          success
          message
        }
      }
    `;


export const User_Profile_Query = gql`
query  userProfile($userId:Int!){
  userProfile(userId:$userId){
    id
    accountId
    name
    surname
    designation
    joiningDate
    profilePicture
    email
    phoneNumber
    gender
    location
  	address
    role
    employeeId
    roleId
    designationId
    higestEducationQualification
    previousExperience
    previousEmployer
    state
    city
    branch
    zone
    dateOfBirth
    employeeType
    reporting{
        name
        employeeId
    }
    reportingDate
  }
}
`;

export const Manager_Reports_Query = gql`
  query getManagerReports($roleId: Int!, $reportingIds: [Int!], $pagingCriteria: PagingCriteria) {
    getUsersForAccount(roleId: $roleId, reportingIds: $reportingIds, pagingCriteria: $pagingCriteria) {
      data {
        id
        name
        surname
        profilePicture
        role
        employeeId
      }
    }
  }
`;

export const Accounts_Query = gql`
      {
        allUserAccount{
          id
          name
          address
          url
          mainLogoUrl
          smallLogoUrl
          criticalSubtaskBg
          brandColor
          emailLogin
          numberLogin
          selfRegistration
          address2
          numberOfRoles
          clanNeeded
          syncNeeded
          dartsNeeded
          lenseNeeded
          syncNeeded
          numberLogin
          emailLogin
      }  
      }
    `;

export const Account_Form_Query = gql`
    mutation addAccount($name: String!, $address: String!, $address2: String!, $roleName: String!, $pocName:String!, $pocEmail:String!, $pocNumber:String!, $selfRegistration:Boolean!, $url: String!, $mainLogo: String!, $smallLogo: String!, $emailLogin: Boolean!, $numberLogin: Boolean!, $brandColor:String!, $clanNeeded: Boolean!, $syncNeeded: Boolean!, $dartsNeeded: Boolean!, $lenseNeeded: Boolean!, $assignedUsersForClient: [Int!]!, $jobroleAccessUserIds: [Int!]!){
      addAccount(name:$name, address:$address, address2:$address2, roleName:$roleName, pocEmail:$pocEmail, pocNumber:$pocNumber, pocName:$pocName, selfRegistration:$selfRegistration, url:$url, mainLogo: $mainLogo, smallLogo: $smallLogo, emailLogin: $emailLogin, numberLogin: $numberLogin, brandColor: $brandColor, dartsNeeded:$dartsNeeded, clanNeeded:$clanNeeded, syncNeeded:$syncNeeded, lenseNeeded:$lenseNeeded, assignedUsersForClient: $assignedUsersForClient, jobroleAccessUserIds: $jobroleAccessUserIds) {
          data {
            id
            
          }
          success
          message
        }
      }
    `;

export const Designations_Query = gql`
query getDesignations($accountId:Int!){
      getDesignations(accountId:$accountId){
        id
        accountId
        jobroleId
        designation
        ppm
        status
    }  
    }
  `;
// ($accountId:Int!)
// (accountId:$accountId)
export const Role_Account_Query = gql`   
    query getAllJobrole($accountId:Int){
    getAllJobrole(accountId:$accountId){
      id
      name
      numberLogin
      emailLogin
       targetEditDays
      inputEditDays
      pocEmail
      pocName
      pocContactNumber
      clanNeeded
      syncNeeded
      dartsNeeded
      syncNeeded
      dartsFormNeeded
      mandatoryTimeDistribution
      signInSignOutRequired
      locationRequired
      ldmsNeeded
      mirrorNeeded
      geoTracking
      hrServicesNeeded
      dartsFormNeeded
      account{
        id
        name
    }
  }
  }  
`;

export const User_Update_Query = gql`
    mutation updateUserProfile($accountId: Int!, $name: String!, $email: String!, $phoneNumber: String!, $employeeId: String!, $location: String!, $gender: String!, $designation: Int!, $address: String!, $currentRoleId: Int!, $joiningDate:Date!){
      updateUserProfile(accountId:$accountId, name:$name,  email:$email, phoneNumber:$phoneNumber, employeeId:$employeeId, location:$location, gender:$gender,designation:$designation, address:$address, currentRoleId:$currentRoleId, joiningDate:$joiningDate) {
          data {
            id
            name
            joiningDate
            gender
          }
          success
          message
        }
      }
    `;

export const List_Contents_Query = gql`
query listVideos($roleId:Int!){
  listVideos(roleId:$roleId){
      id
      title
      description
      vimeoId
      fourmatCategory
      activityName
      taskName
      subtaskName
  }
}
  `;

export const Content_Form_Query = gql`
  mutation addContent($accountId: Int!,$roleId: Int!, $subtaskId: Int!, $title: String!, $code: String!, $description: String!, $thumbnailUrl: String!, $lengthMins: String!, $category: String!,  $userId:Int!, $languageId:Int!){
    addContent(accountId:$accountId, roleId:$roleId, subtaskId:$subtaskId,  title:$title, code:$code, description:$description, thumbnailUrl:$thumbnailUrl,lengthMins:$lengthMins, category:$category, userId:$userId, languageId:$languageId) {
        data {
          id
          
        }
        success
        message
      }
    }
  `;
export const Role_Activities_Query = gql`   
  query getActivitiesByRole($jobrole: Int!){
    getActivitiesByRole(jobrole:$jobrole){
    id
    name
    jobrole
    taskCount
    rankValue
}
}  
`;

export const Get_Task_Activity_Query = gql`   
  query getTaskByActivity($activityId:Int!, $roleId: Int!){
    getTaskByActivity(activityId:$activityId, roleId: $roleId){
    id
    name
    subtaskCount
    activityRank
    rankValue
}
}  
`;

export const Get_Subtask_Task_Query = gql`   
  query getSubtaskByTask($taskId:Int!, $roleId:Int!){
    getSubtaskByTask(taskId:$taskId, roleId:$roleId ){
    id
    name
    videoCount
    isCritical
}
}  
`;
// ($accountId:Int!)
// (accountId:$accountId)
export const Non_Beta_list_Query = gql`   
    query getNotExpert($accountId: Int!){
      getNotExpert(accountId:$accountId){
      id
      name
  }
  }  
`;

export const Beta_Form_Query = gql`
    mutation updateExpert($userId:Int!,$profileSummary: String!, $introVideoCode: String!, $introVideoThumb: String!, $phoneNumber: String!){
      updateExpert(userId:$userId,profileSummary:$profileSummary, introVideoCode:$introVideoCode, introVideoThumb:$introVideoThumb, phoneNumber:$phoneNumber) {
          data {
            introVideoThumb
            introVideoCode
            phoneNumber
            id
            name            
          }
          success
          message
        }
      }
    `;
// ($accountId:Int!)
// (accountId:$accountId)
export const BETA_LIST_Query = gql`   
    query getAllExpert($roleId:Int!){
      getAllExpert(roleId:$roleId){
        id
        name
        phoneNumber
        designation
        role
  }
  }  
`;


export const Beta_Data_Query = gql`   
    query getExpertProfile($userId:Int!){
      getExpertProfile(userId:$userId){
      id
      name
      introVideoThumb
      introVideoCode
      profileSummary
      phoneNumber
      accountId
  }
  }  
`;

export const List_Notifications_Query = gql`
    {   
      getWebadminNotification{
        id
        title
        description
        targetUserId
        createdAt
        eventType
    }
}
  `;
// $userId: Int!, $title: String!, $description: String!
// userId:$userId, title:$title, description:$description
export const Notification_Form_Query = gql`
  mutation createNewWebNotification($data: [Bulknotifications!]!){
    createNewWebNotification(data:$data) {
        data {
          id
          notificationRead
        }
        success
        message
      }
    }
  `;

export const Add_JobRole_Query = gql`
    mutation addJobrole($name: String!, $accountId: Int!){
      addJobrole(name:$name, accountId:$accountId) {
          data {
            id
            name
          }
          success
          message
        }
      }
    `;

export const Add_Activity_Query = gql`
    mutation addActivity($name: String!, $jobroleId: Int!, $afterActivityId:Int!){
      addActivity(name:$name, jobroleId:$jobroleId, afterActivityId:$afterActivityId) {
          data {
            id
            name
          }
          success
          message
        }
      }
    `;
export const Add_Task_Query = gql`
    mutation addTasks($name: String!, $activityId: Int!, $afterTaskId:Int!){
      addTasks(name:$name, activityId:$activityId, afterTaskId:$afterTaskId) {
          data {
            id
            name
          }
          success
          message
        }
      }
    `;

export const Add_SubTask_Query = gql`
    mutation addSubtasks($name: String!, $taskId: Int!, $isCritical: Boolean!, $nonCriticalDescription: String!, $rankForRecommendation: Int!, $afterSubTaskId: Int!){
      addSubtasks(name:$name, taskId:$taskId, isCritical:$isCritical, nonCriticalDescription:$nonCriticalDescription, rankForRecommendation: $rankForRecommendation, afterSubTaskId:$afterSubTaskId) {
          data {
            id
            name
          }
          success
          message
        }
      }
    `;
// [{$empId: String!, $monthDetails: Date!, $performance: String!}]
// [{empId:$empId, monthDetails:$monthDetails, performance:$performance
export const Create_Performance_Query = gql`    
    mutation createPerformanceCapture($data: [Performancecaptureparameters!]!){
      createPerformanceCapture(data:$data)  {
          data {
            accountId
            empId
          }
          success
          message
        }
      }
    `;
export const User_Bulk_Upload_Query = gql`    
    mutation addMutlipleUsers($data: [AddUser!]!){
      addMutlipleUsers(data:$data){
          data {
            data
            message
          }
          
          message
          success
        }
      }
    `;

export const Update_User_Bulk_Upload_Query = gql`    
    mutation updateMutlipleUsers($data: [AddUser!]!){
      updateMutlipleUsers(data:$data){
          data {
            data
            message
          }
          
          message
          success
        }
      }
    `;
export const List_Languages_Query = gql`
    {   
      mdLanguages{
        id
        code
        name
    }
}
  `;
export const SubTask_Bulk_Upload_Query = gql`    
  mutation addMultipleSubTasks($data: [AddActivityTaskSubTask!]!){
    addMultipleSubTasks(data:$data){
        data {
          data
          message
        }
        
        message
        success
      }
    }
  `;

export const User_Account_Query = gql`
      {
        currentUserAccount{
       id
       name
       mainLogoUrl
       smallLogoUrl
   }
      }
    `;
// input PerformanceInput{
//   empId: String!
//   monthDetails: String!
//   performance: String!
// }

export const jobroles_count_Query = gql`
query getAdminDashboard($accountId:Int!){
  getAdminDashboard(accountId:$accountId){
    roleName
    numberOfMembers
    }  
    }
  `;

export const Current_User_Profile_Query = gql`
  {
    currentUserProfile{
   id
   name
   roleId
}
  }
`;

export const Funnel_Query = gql`
query getKpiRatios($roleId:Int!){
  getKpiRatios(roleId:$roleId){
      imageUrl
      data{
          id
          kpiId
          kpiName
          kpiVersion
          relationKpiId
          relationKpiName
          relationPer
      }
  }
}
    `;

export const Create_Funnel_Query = gql`    
    mutation kpiRelationChange($data: [KpiRelationChange!]!){
      kpiRelationChange(data:$data)  {
          data {            
            kpiId,
            relationPer,
            kpiVersion
          }
          success
          message
        }
      }
    `;

export const State_Query = gql`
    {
      getStates{
     id
     stateName
  }
    }
  `;

export const City_Query = gql`
  query getCity($stateId:Int!){
    getCity(stateId:$stateId){
      id
      cityName
      }  
      }
  `;

export const Verify_EMPID_Query = gql`
  query verifyEmployeeId($employeeId:String!){
    verifyEmployeeId(employeeId:$employeeId){
      id
      isExpert
      employeeId
      name
      }  
      }
  `;

export const Get_Lense_Account = gql`
  query GetLenseAccount{
    getLenseAccount{
        id
        name
        address
        image
        imageUrl
        role
    }
}`

export const Get_Lense_Account_Projects = gql`
query GetLenseAccountProjects($clientId:String!){
  getLenseAccountProjects(clientId:$clientId){
      id
      name
      __typename
  }
}`

export const Upload_Document = gql`
mutation uploadDocument ($s3folder: S3folder!, $document: Upload!) {
  uploadDocument (s3folder: $s3folder, document: $document) {
      success
      message
      data {
          data
      }
  }
}`

export const update_Account = gql`
  mutation updateAccount(
    $accountId: Int!,
    $name: String!,
    $address: String!,
    $address2: String!,
    $url: String!,
    $mainLogo: String,
    $smallLogo: String,
    $emailLogin: Boolean!,
    $numberLogin: Boolean!,
    $brandColor: String!,
    $selfRegistration : Boolean!,
    $assignedUsersForClient: [Int!]!,
  ) {
    updateAccount(
      accountId: $accountId,
      name: $name,
      address: $address,
      address2: $address2,
      url: $url,
      mainLogo: $mainLogo,
      smallLogo: $smallLogo,
      emailLogin: $emailLogin,
      numberLogin: $numberLogin,
      brandColor: $brandColor,
      selfRegistration : $selfRegistration,
      assignedUsersForClient: $assignedUsersForClient,  
    ) {
      success
      message
      data {
        id
        name
        address
        url
        brandColor
        criticalSubtaskBg
        mainLogoUrl
        smallLogoUrl
        emailLogin
        numberLogin
        availableLanguages {
          code
        }
        lenseId
      }
    }
  }
`;

export const Role_Management = gql`
    mutation AddJobRole(
        $accountId: Int!
        $name: String!
        $clanNeeded: Boolean!
        $syncNeeded: Boolean!
        $dartsNeeded: Boolean!
        $dartsFormNeeded: Boolean!
        $jobroleId: Int
        $pocName: String!
        $pocEmail: String!
        $pocNumber: String!
        $geoTracking: Boolean!
        $numberLogin: Boolean!
        $emailLogin: Boolean!
        $mandatoryTimeDistribution: Boolean!
        $signInSignOutRequired: Boolean!
        $locationRequired: Boolean!
        $targetEditDays: Int!
        $inputEditDays: Int!
        $jobroleAccessUserIds: [Int!]!
        $ldmsNeeded: Boolean!
        $mirrorNeeded: Boolean!
    ) {
        addJobrole(
            accountId: $accountId
            name: $name
            clanNeeded: $clanNeeded
            syncNeeded: $syncNeeded
            dartsNeeded: $dartsNeeded
            dartsFormNeeded: $dartsFormNeeded
            jobroleId: $jobroleId
            pocName: $pocName
            geoTracking: $geoTracking
            pocEmail: $pocEmail
            pocNumber: $pocNumber
            numberLogin :$numberLogin
            emailLogin: $emailLogin
            mandatoryTimeDistribution: $mandatoryTimeDistribution
            targetEditDays: $targetEditDays
            inputEditDays: $inputEditDays 
            jobroleAccessUserIds: $jobroleAccessUserIds
            signInSignOutRequired: $signInSignOutRequired
            locationRequired: $locationRequired
            ldmsNeeded: $ldmsNeeded
            mirrorNeeded: $mirrorNeeded
        ) {
            success
            message
            data {
                id
                name
                account {
                    id
                }
                clanNeeded
                syncNeeded
                dartsNeeded
                dartsFormNeeded
            }
        }
    }
`;

export const Get_All_Job_Role = gql`
query GetAllJobrole($accountId: Int) {
  getAllJobrole(accountId: $accountId) {
   id
    name
    account {
      id
      name
      address
      url
      brandColor
      criticalSubtaskBg
      mainLogoUrl
      smallLogoUrl
      emailLogin
      numberLogin
      availableLanguages{
        code
      }
      lenseId
      selfRegistration
      address2
    }
    targetEditDays
    inputEditDays
    pocEmail
    pocName
    pocContactNumber
    clanNeeded
    syncNeeded
    dartsNeeded
    syncNeeded
    dartsFormNeeded
    mandatoryTimeDistribution
  }
}`

export const List_All_Super_Admins = gql`
query listAllSuperadmins($searchString : String, $pagingCriteria : PagingCriteria! ){
  listAllSuperadmins(
    searchString: $searchString
    pagingCriteria: $pagingCriteria
  ) {
    data {
      id
      firstName
      surname
      email
      password
      contactNumber
      profilePicture
      userType
      userStatus
      roleName
      roleId
    }
    pageMeta {
      nextPage
      previousPage
      hasNextPage
      hasPreviousPage
      totalCount
    }
  }
}`



export const Add_update_super_admins = gql`
mutation addUpdateSuperAdmins ($updatedUser: UpdateAdminUsers!) {
  addUpdateSuperAdmins (updatedUser: $updatedUser) {
    success
    message
    data {
      id
      firstName
      surname
      email
      password
      contactNumber
      profilePicture
      userType
      userStatus
      roleName
      roleId
      password
    }
  }
}`


export const Delete_Account = gql`
    mutation deleteAccount($accountId: Int!){
      deleteAccount(accountId:$accountId) { 
          success
          message
          data
        }
      }`;

export const Delete_Job_Role = gql`
    mutation deleteJobrole($jobroleId: Int!){
      deleteJobrole(jobroleId:$jobroleId) { 
          success
          message
          data
        }
      }`;

export const GET_User_For_Account = gql`
      query getUsersForAccount(
        $roleId: Int!, 
        $filterByName: String, 
        $pagingCriteria: PagingCriteria
      ) {
        getUsersForAccount(
          roleId: $roleId, 
          filterByName: $filterByName, 
          pagingCriteria: $pagingCriteria
        ) {
          data {
            id
            name
            fullname
            debug
            profilePicture
            designation
            employeeId
            title
            role
            roleId
            expiringUrl {
              url
            }
            ppm
            gender
            userCharacter
            surname
            dateOfBirth
            email
            genderId
            employeeTypeId
            phoneNumber
            designationId
            location
            profileActivated
            preferredLanguages {
              id
            }
            isExpert
            joiningDate
            roleStartDate
            reporting {
              id
            }
            reportingDate
            address
            accountId
            pointsBadges
            coins
            clanNeeded
            syncNeeded
            dartsNeeded
            mandatoryProjectTime
            dartsFormNeeded
            numberOfAssociates
            numberOfManagers
            userContentAgreement
            employeeType
            branch
            city
            state
            zone
            higestEducationQualification
            previousEmployer
            previousExperience
          }
          pageMeta {
            nextPage
            previousPage
            hasNextPage
            hasPreviousPage
            totalCount
          }
        }
      }
    `;

export const GET_User_Details_User_Management = gql`
    query getUsersForAccount_ ($roleId: Int!, $filterByName: String, $joiningDateFilter:DateTime, $pagingCriteria: PagingCriteria, $filters: [JSON!], $reportingIds: [Int!]) {
      getUsersForAccount (roleId: $roleId, filterByName: $filterByName, joiningDateFilter:$joiningDateFilter, pagingCriteria: $pagingCriteria, filters: $filters, reportingIds: $reportingIds) {
        data {
               id
        name
        fullname
        debug
        designation
        employeeId
        title
        role
        roleId
        employeeId
        stateName
        cityName
        gender
        genderId
        employeeTypeId
        surname
        status
        dateOfBirth
        email
        phoneNumber
        designationId
        location
        profileActivated
        preferredLanguages {
            id
            code
            name
        }
        userType {
             id
            userType
       }
        assignedToUser {
            id
            name
        }
        isExpert
        joiningDate
        roleStartDate
        reporting {
            id
            name
            profilePicture
            designation
            employeeId
            title
            role
            roleId
            ppm
            gender
            userCharacter
        }
        reportingDate
        address
        accountId
        accountName
        clanNeeded
        syncNeeded
        dartsNeeded
        dartsFormNeeded
        numberOfAssociates
        numberOfManagers
        userContentAgreement
        employeeType
        branch
        city
        state
        zone
        higestEducationQualification
        previousEmployer
        previousExperience
          }
          pageMeta {
              nextPage
              previousPage
              hasNextPage
              hasPreviousPage
              totalCount
          }
      }
  }`;

export const GET_User_Details_User_Management_Role_Management_View = gql`
    query getUsersForAccount_ ($roleId: Int!, $filterByName: String, $joiningDateFilter:DateTime, $pagingCriteria: PagingCriteria, $filters: [JSON!], $reportingIds: [Int!]) {
      getUsersForAccount (roleId: $roleId, filterByName: $filterByName, joiningDateFilter:$joiningDateFilter, pagingCriteria: $pagingCriteria, filters: $filters, reportingIds: $reportingIds) {
        data {
               id
        name
        fullname
        debug
        surname
        designation
        employeeId
        employeeId
        cityName
        status
        email
        phoneNumber
        profileActivated
        userType {
             id
            userType
        } 
        reporting {
              id
              name
        }


        isExpert
        joiningDate
        employeeType
        branch
          }
          pageMeta {
              nextPage
              previousPage
              hasNextPage
              hasPreviousPage
              totalCount
          }
      }
  }`;

export const GET_User_Details_User_Management_For_UserProfile = gql`
    query getUsersForAccount_ ($roleId: Int!, $filterByName: String, $joiningDateFilter:DateTime, $pagingCriteria: PagingCriteria, $filters: [JSON!], $reportingIds: [Int!]) {
      getUsersForAccount (roleId: $roleId, filterByName: $filterByName, joiningDateFilter:$joiningDateFilter, pagingCriteria: $pagingCriteria, filters: $filters, reportingIds: $reportingIds) {
        data {
               id
              name
              surname
              fullname
              debug
              profilePicture
              appLanguage {
                id
                language
              }
               reporting {  
                 profilePicture
              }
          }
      }
  }`;

export const GET_User_Details_User_Management_For_RootAdmin = gql`
   query getUsersForAccount_ ($roleId: Int!, $filterByName: String, $joiningDateFilter:DateTime, $pagingCriteria: PagingCriteria, $filters: [JSON!], $reportingIds: [Int!]) {
      getUsersForAccount (roleId: $roleId, filterByName: $filterByName, joiningDateFilter:$joiningDateFilter, pagingCriteria: $pagingCriteria, filters: $filters, reportingIds: $reportingIds) {
        data {
               id
               surname
        name
        fullname
        debug
        designation
        employeeId
        employeeId
        cityName
        email
        phoneNumber
        profileActivated
        reporting {
              id
              name
        }
        userType {
             id
            userType
       }
        joiningDate
        accountId
        branch
          }
          pageMeta {
              nextPage
              previousPage
              hasNextPage
              hasPreviousPage
              totalCount
          }
      }
  }`;

export const Get_Designation = gql`
  query getDesignations ($accountId: Int) {
    getDesignations (accountId: $accountId) {
        id
        accountId
        jobroleId
        designation
        ppm
        status
    }
}`

export const Get_States = gql`
query getStates {
  getStates {
      id
      stateName
  }
}`

export const Get_City = gql`
query getCity ($stateId: Int!) {
  getCity (stateId: $stateId) {
      id
      cityName
  }
}`

export const Current_Designation = gql`
query getDesignationsJobroleid ($jobroleId: Int!){
  getDesignationsJobroleid(jobroleId: $jobroleId) {
    id
    accountId
    jobroleId
    designation
    ppm
    status
  }
}`

export const Add_Multiple_Users = gql`
  mutation addMultipleUsers($data: [AddUser!]!) {
    addMultipleUsers(data: $data) {
      success
      message
      data {
        data
        message
      }
    }
  }`

export const Remove_User = gql`
    mutation removeUser($userId: Int!) {
    removeUser(userId: $userId) {
      success
      message
      data {
      id
      name
      numberOfAssociates
      numberOfManagers
    }
    }
  }`

export const Remove_Super_Manager = gql`
  mutation removeSuperManager($userId: Int!) {
    removeSuperManager(userId: $userId) {
      success
      message
      data {
      id
      name
      numberOfAssociates
      numberOfManagers
     }
    }
  }`

export const Remove_Manager = gql`
  mutation removeManager($userId: Int!) {
    removeManager(userId: $userId) {
       success
      message
      data {
      id
      name
      numberOfAssociates
      numberOfManagers
     }
    }
  }`

export const Remove_Manager_Make_Super_Manager = gql`
  mutation removeManagerMakeSuperManagerAsManager($userId: Int!) {
    removeManagerMakeSuperManagerAsManager(userId: $userId) {
      success
      message
      data {
        id
        name
        numberOfAssociates
        numberOfManagers
      }
    }
  }`

export const Get_Associate_Members_Count = gql`
  query getAssociateMembersCount($userId: Int!) {
    getAssociateMembersCount(userId: $userId)
  }`

export const Get_Associate_Members = gql`
  query getAssociateMembers($userId: Int!) {
    getAssocateMembers(userId: $userId) {
      id
      name
      employeeId
      email
      profilePicture
      userType {
        id
        userType
      }
      reporting {
        id
        name
      }
    }
  }`

export const Assign_Super_Manager_As_Manager = gql`
  mutation assignSuperManagerAsManager($managerId: Int!) {
    assignSuperManagerAsManager(managerId: $managerId) {
      success
      message
    }
  }`

export const Reassign_Users_To_Manager = gql`
  mutation reassignUsersToManager($assignments: [UserManagerAssignment!]!) {
    reassignUsersToManager(assignments: $assignments) {
      success
      message
    }
  }`

export const Delete_Manager_Assign_One_Of_Remaining_Managers = gql`
  mutation deleteManagerAssignOneOfTheRemaningManagers($data: [ReAssignManager!]!) {
    deleteManagerAssignOneOfTheRemaningManagers(data: $data) {
      success
      message
    }
  }`

export const Update_User = gql`
  mutation updateMultipleUsers ($data: [AddUser!]!) {
    updateMultipleUsers (data: $data) {
        success
        message
        data {
            data
            message
        }
    }
}`


export const Bulk_Upload = gql`
mutation ($accountId: Int!, $roleId: Int!, $document: Upload!){
  bulkUploadUsers(accountId: $accountId, roleId: $roleId, document: $document) {
    success
    message
    data
  }
}`

export const Bulk_Upload_Sheet = gql`
query getBulkUploadExcel($roleId: Int!) {
  getBulkUploadExcel(roleId: $roleId)
}`

export const Get_Designation_Users_Count = gql`
query getDesignationUsersCount($accountId: Int!, $jobroleId: Int!, $designationId: Int!) {
  getDesignationUsersCount(accountId: $accountId, jobroleId: $jobroleId, designationId: $designationId)
}`

export const Get_Gender_Users_Count = gql`
query getGenderUsersCount($accountId: Int!, $jobroleId: Int!, $genderId: Int!) {
  getGenderUsersCount(accountId: $accountId, jobroleId: $jobroleId, genderId: $genderId)
}`

export const Get_Employment_Type_Users_Count = gql`
query getEmploymentTypeUsersCount($accountId: Int!, $jobroleId: Int!, $employmentTypeId: Int!) {
  getEmploymentTypeUsersCount(accountId: $accountId, jobroleId: $jobroleId, employmentTypeId: $employmentTypeId)
}`

export const Add_Update_Designation = gql`
mutation ($accountId: Int!, $jobroleId:Int!, $designationName:String!, $designationId: Int, $status:Int)
{
  addUpdateDesignations(
    accountId: $accountId,
    jobroleId: $jobroleId,
    designationName: $designationName,
    designationId: $designationId,
    status:$status
  ) {
    success
    message
    data {
      id
      accountId
      jobroleId
      designation
      ppm
      status
    }
  }
}`

export const Verify_Employee_Id = gql`
query ($employeeId: String!) {
  verifyEmployeeId(employeeId: $employeeId) {
    id
    name
    employeeId
  }
}`

export const Dashboard_API = gql`
query GetDashboardValues {
  getDashboardValues {
    totalUsers
    totalClients
    totalRoles
    totalClanUsers
    totalDartsUsers
    totalLenseUsers
  }
}`

export const Get_ClientWise_DetailsForAdmin = gql`
query GetClientWiseDetailsForAdmin($searchTerm:String!, $sortBy:Int!){
  getClientWiseDetailsForAdmin(searchTerm: $searchTerm, sortBy: $sortBy) {
    account {
      id
      name
      mainLogoUrl
      smallLogoUrl
    }
    numberOfRoles
    numberOfSupermanagers
    numberOfManagers
    numberOfUsers
    numberOfUsersInLense
    numberOfUsersInClan
    numberOfUsersInDarts
  }
}`

export const ADD_MULTIPLE_JOBROLES = gql`
mutation addMultipleJobroles($accountId: Int!, $jobroles: [MultipleJobroleInput!]!){
  addMultipleJobroles(accountId: $accountId, jobroles: $jobroles) {
    success
    message
    data {
      id
      name
      targetEditDays
      inputEditDays
      pocEmail
      pocName
      pocContactNumber
      clanNeeded
      dartsNeeded
      dartsFormNeeded
      ldmsNeeded
      hrServicesNeeded
      syncNeeded
      numberLogin
      emailLogin
      mandatoryTimeDistribution
      mirrorNeeded
      signInSignOutRequired
      locationRequired
      powerBiReport
      geoTracking
      incentiveNeeded
      account {
        address
      }
    }
  }
}`

export const List_Gender_From_Role = gql`
query listGenderFromRole ($jobroleId: Int!){
  listGenderFromRole(jobRoleId: $jobroleId) {
    id
    name
    roleId
    code
  }
}`

export const Add_Update_Gender_Master = gql`
mutation ($genderName:String!, $genderCode: String!, $jobRoleId: Int!, $status:Int, $genderId:Int){
addUpdateGenderMaster(genderName: $genderName, genderCode: $genderCode, jobRoleId: $jobRoleId, status:$status, genderId:$genderId
  ) {
    success
    message
    data {
      id
      name
      roleId
      code
    }
  }
}`


export const List_Employement_Type_From_Role = gql`
query listEmployementTypeFromRole ($jobRoleId: Int!){
  listEmployementTypeFromRole(jobRoleId: $jobRoleId) {
    id
    name
    roleId
  }
}`

export const Add_Update_Employement_Type = gql`
mutation ($employementType:String!, $jobRoleId:Int!, $status:Int, $employmentTypeId:Int){
  addUpdateEmployementType(employementType: $employementType, jobRoleId: $jobRoleId, status:$status, employmentTypeId:$employmentTypeId) {
    success
    message
    data {
      id
      name
      roleId
    }
  }
}`

export const TargetFunnel = gql`
mutation ($accountId: Int!, $roleId: Int!, $kpiId: Int, $kpiName: String!, $kpiDefaultTarget: Int!, $kpiColorCode: String!, $status: Int) {
  saveKpiMasterDetails(
    accountId: $accountId
    roleId: $roleId
    kpiName: $kpiName
    kpiDefaultTarget: $kpiDefaultTarget
    kpiColorCode: $kpiColorCode
    kpiId: $kpiId
    status: $status
  ) {
    success
    message
    data {
      id
      name
      defaultValue
      colorValue
    }
  } 
}`

export const Get_TargetFunnel = gql`
query ($roleId: Int!) {
  getKpisForRole(roleId: $roleId) {
    id
    name
    defaultValue
    colorValue
  }
}`


export const LeadFunnel = gql`
mutation (
    $accountId: Int!,
    $roleId: Int!,
    $kiiId: Int,
    $kiiName: String!,
    $kiiDefaultTarget: Int!,
    $kiiDailyTarget: Int!,
    $kiiColorCode: String!,
    $status: Int
  ) {
  saveKiiMasterDetails(
    accountId: $accountId
    roleId: $roleId
    kiiName: $kiiName
    kiiDailyTarget: $kiiDailyTarget
    kiiDefaultTarget: $kiiDefaultTarget
    kiiColorCode: $kiiColorCode
    kiiId: $kiiId
    status: $status
  ) {
    success
    message
    data {
      id
      name
      defaultValue
      dailyTarget
      colorValue
    }
  }
}`


export const Get_LeadIndicatorFunnel = gql`
query ($roleId: Int!){
  getKiisForRole(roleId: $roleId) {
    id
    name
    defaultValue
    dailyTarget
    colorValue
  }
}`


export const Add_Update_KiiKpiRelation = gql`
mutation ($data: [InputKpiKiiRelation!]!) {
    addUpdateKiiKpiRelation(data: $data) {
    success
    message
    data {
      id
      kpiId
      kpiName
      kiiId
      kiiName
      relationKpiKii
      status
      kpiVersion
    }
  }
}`

export const Get_KiiKpiRelationDetails = gql`
query ($roleId: Int!) {
  getKiiKpiRelationDetails(roleId: $roleId) {
    id
    kpiId
    kpiName
    kiiId
    kiiName
    relationKpiKii
    status
    kpiVersion
  }
}`

export const Get_KiiKpiRelationDetailsById = gql`
mutation ($kpiKiiRelation: Int!) {
  deleteKpiKiiRelation(kpiKiiRelation: $kpiKiiRelation) {
    success
    message
    data {
      id
      kpiId
      kpiName
      kiiId
      kiiName
      relationKpiKii
      status
      kpiVersion
    }
  }
}`



export const GET_OS_TICKETING_DASHBOARD_VALUES = gql`
query getOsTicketingDashboardValues($startDate: String!, $endDate: String!){
  getOsTicketingDashboardValues(startDate: $startDate, endDate: $endDate) {
    assignedTickets
    closedTickets
    openTickets
    overdueTickets
    reOpenedTickets
    deletedTickets
    serviceTimeInMinutes
    responceTimeInMinutes
  }
}`


export const Add_Update_Attendance_Types = gql`
mutation ($accountId: Int!, $roleId: Int!, $attendanceType: String!, $status: Int, $attendanceTypeId: Int) {
  addUpdateAttendanceTypes(
    accountId: $accountId
    roleId: $roleId
    attendanceType: $attendanceType
    status: $status
    attendanceTypeId: $attendanceTypeId
  ) {
    success
    message
    data {
      id
      status
    }
  }
}`

export const List_Attendance_Types = gql`
query listAttendanceTypes($accountId: Int!, $jobRoleId: Int!){
  listAttendanceTypes(accountId: $accountId, jobRoleId: $jobRoleId) {
    id
    attendanceType
    status
  }
}`


export const Get_Time_Distribution_For_Role = gql`
query getTimeDistributionForRole($accountId: Int!, $roleId: Int!){
  getTimeDistributionForRole(accountId: $accountId, roleId: $roleId) {
    id
    projectName
    projectNorm
    depends
    userValue
  }
}`

export const Add_Update_Time_Distribution = gql`
  mutation AddUpdateTimeDistribution($data: [AddUpdateTimeDistribution!]!) {
    addUpdateTimeDistribution(data: $data) {
      success
      message
      data {
        id
        projectName
        projectNorm
        depends
        userValue
        status
      }
    }
  }
`;


export const Get_User_Profile = gql`
query getUserProfile($userId: Int!)
{
  userProfile(userId: $userId) {
    id
    name
    surname
    fullname
    profilePicture
    designation
    employeeId
    title
    role
    roleId
    ppm
    gender
    userCharacter
    surname
    dateOfBirth
    email
    phoneNumber
    designationId
    location
    profileActivated
    userType {
      id
      userType
    }
    performanceResidency {
      performance
      residency
      color
    }
    preferredLanguages {
      id
      code
      name
    }
    isExpert
    joiningDate
    roleStartDate
    reporting {
      id
      name
      profilePicture
      designation
      employeeId
      title
      role
      roleId
      ppm
      gender
      userCharacter
    }
    reportingDate
    genderId
    address
    accountId
    accountName
    pointsBadges
    coins
    clanNeeded
    syncNeeded
    dartsNeeded
    mandatoryProjectTime
    dartsFormNeeded
    numberOfAssociates
    numberOfManagers
    userContentAgreement
    employeeType
    employeeTypeId
    branch
    city
    cityName
    state
    stateName
    zone
    appLanguage {
      id
      language
      languageCode
      languageCountryCode
      introVideoCode
    }
    higestEducationQualification
    previousEmployer
    previousExperience
    password
  }
}`

export const Get_User_Device_Details = gql`
  query getUserDeviceDetails($userId: Int!) {
    getUserDeviceDetails(userId: $userId) {
      id
      deviceId
      userId
      fcmToken
      deviceName
      deviceModel
      os
      osVersion
    }
  }
`

export const Get_User_Profile_For_UserProfile = gql`
query getUserProfile($userId: Int!)
{
  userProfile(userId: $userId) {
    id
    name
  }
}`


export const Get_Activity_By_Role = gql`
query listActivities ($jobroleId: Int!,$fullHierarchy: Boolean!, $pagingCriteria: PagingCriteria, $searchTerm: String) {
  listActivities (jobroleId: $jobroleId,fullHierarchy: $fullHierarchy, pagingCriteria: $pagingCriteria, searchTerm: $searchTerm) {
      data {
          id
          name
          code
          taskCount
          subtaskCount
          criticalSubtaskCount
          videoCount
          jobrole
          rankValue
      }
      pageMeta {
          nextPage
          previousPage
          hasNextPage
          hasPreviousPage
          totalCount
      }
  }
}`

export const Get_Video_Activity_By_Role = gql`
query listCriticalActivities ($jobroleId: Int!,$searchTerm: String) {
  listCriticalActivities (jobroleId: $jobroleId,searchTerm: $searchTerm) {
          id
          name
          code
          taskCount
          subtaskCount
          criticalSubtaskCount
          videoCount
          jobrole
          rankValue
  }
}`

export const Add_Activity = gql`
mutation addActivity ($jobroleId: Int!, $name: String!, $afterActivityId: Int!, $activityId: Int,$status: Int) {
  addActivity (
      jobroleId: $jobroleId, 
      name: $name, 
      afterActivityId: $afterActivityId,
       activityId: $activityId,
        status: $status
      ) {
      success
      message
      data {
          id
          name
          code
          taskCount
          videoCount
          jobrole
          rankValue
          
      }
  }
}`


export const Add_Task = gql`
mutation addTasks ($activityId: Int!, $name: String!, $afterTaskId: Int!, , $taskId: Int, $status: Int) {
  addTasks (activityId: $activityId, name: $name, afterTaskId: $afterTaskId, taskId: $taskId, status: $status) {
      success
      message
      data {
          id
          code
          name
          subtaskCount
          videoCount
          activityRank
          rankValue
      }
  }
}`


export const Get_Task_By_Activity = gql`
query getTaskByActivity ($activityId: Int!, $roleId: Int, $searchTerm: String) {
  getTaskByActivity (activityId: $activityId, roleId: $roleId, searchTerm: $searchTerm) {
      id
      code
      name
      subtasks {
          id
          code
          name
          isCritical
          nonCriticalDescription
          linkedContentId
          videoCount
          taskId
      }
      subtaskCount
      videoCount
      activityRank
      rankValue
  }
}`

export const Get_Video_Task_By_Activity = gql`
query listCriticalTasks ($activityId: Int!, $searchTerm: String) {
  listCriticalTasks (activityId: $activityId, searchTerm: $searchTerm) {
    id
    code
    name
    subtaskCount
    videoCount
    activityRank
    rankValue
  }
}`

export const Add_Subtask_By_Task = gql`
mutation addSubtasks ($taskId: Int!, $name: String!, $isCritical: Boolean!, $nonCriticalDescription: String!, $rankForRecommendation: Int!, $afterSubTaskId: Int!, $subtaskId: Int, $status: Int) {
  addSubtasks (taskId: $taskId, name: $name, isCritical: $isCritical, nonCriticalDescription: $nonCriticalDescription, rankForRecommendation: $rankForRecommendation, afterSubTaskId: $afterSubTaskId, subtaskId: $subtaskId, status: $status) {
      success
      message
      data {
          id
          code
          name
          isCritical
          nonCriticalDescription
          linkedContentId
          videoCount
          taskId
      }
  }
}`

export const Get_Subtask_By_Task = gql`
query listSubtasksForTask( $taskId: Int!, $fullHierarchy: Boolean!, $searchTerm: String) {
  listSubtasksForTask(taskId: $taskId, fullHierarchy: $fullHierarchy, searchTerm: $searchTerm) {
    id
    code
    name
    isCritical
    nonCriticalDescription
    linkedContentId
    videoCount
    taskId
    createdAt
  }
}`

export const Get_Video_Subtask_By_Task = gql`
query listCriticalSubtask( $taskId: Int!, $searchTerm: String) {
  listCriticalSubtask(taskId: $taskId, searchTerm: $searchTerm) {
    id
    code
    name
    isCritical
    nonCriticalDescription
    linkedContentId
    videoCount
    taskId
    createdAt
  }
}`


export const Get_Account_Experts = gql`
query getAccountExperts($pagingCriteria: PagingCriteria!, $accountId: Int!) {
  getAccountExperts(
    pagingCriteria: $pagingCriteria,
    accountId: $accountId
  ) {
    data {
      id
      name
      designation
      title
      role
      ppm
      employeeId
      gender
      dateOfJoining
      branch
      expiringUrl{
        url
      }
      profilePicture
      videosCount
      videoLikesCount
      videoViewsCount
      phoneNumber
      email
      introVideoId
      followers
      location
      pointsBadges
      coins
      status
    }
    pageMeta {
      nextPage
      previousPage
      hasNextPage
      hasPreviousPage
      totalCount
    }
  }
}`


export const Update_Expert = gql`
  mutation updateExpert(
    $userId: Int!,
    $profileSummary: String!,
    $introVideoCode: String!,
    $introVideoThumb: String!,
    $phoneNumber: String!,
    $introVideoTitle: String!,
    $introVideoDescription: String!,
    $introVideoLanguageId: Int!,
    $introVideoLengthInSeconds: Int!,
    $status:Int!
  ) {
    updateExpert(
      userId: $userId,
      profileSummary: $profileSummary,
      introVideoCode: $introVideoCode,
      introVideoThumb: $introVideoThumb,
      phoneNumber: $phoneNumber,
      introVideoTitle: $introVideoTitle,
      introVideoDescription: $introVideoDescription,
      introVideoLanguageId: $introVideoLanguageId,
      introVideoLengthInSeconds: $introVideoLengthInSeconds,
      status: $status
    ) {
      success
      message
      data {
        id
        name
        designation
        title
        role
        ppm
        # expiringUrl
        profilePicture
        videosCount
        videoLikesCount
        videoViewsCount
        phoneNumber
        email
        introVideoId
        followers
        location
        pointsBadges
        coins
        status
      }
    }
  }`


export const Get_Not_Expert_Profile = gql`
  query getNotExpert ($accountId: Int) {
    getNotExpert (accountId: $accountId) {
        id
        name
        surname
        employeeId
    }
}`


export const Get_Expert_Profile = gql`
query getExpertProfile ($userId: Int!) {
  getExpertProfile (userId: $userId) {
      id
      name
      designation
      title
      role
      ppm
      expiringUrl {
          url
          urlExpiry
      }
      profilePicture
      videosCount
      videoLikesCount
      videoViewsCount
      phoneNumber
      email
      introVideoId
      followers
      location
      pointsBadges
      coins
      status
      profileActivated
      accountId
      preferredLanguages {
          id
          code
          name
      }
      connectionStatus {
          id
          connectionStatus
          createdAt
          expertRespondedAt
      }
      avgVideoLikesCount
      avgVideoViewsCount
      videoCommentsCount
      videoSharesCount
      connectRequestCount
      profileSummary
      joiningDate
      roleStartDate
      introVideoCode
      introVideoLanguageId
      introVideoLanguageStr
      introVideoTitle
      introVideoDescription
      introVideoLengthInMin
      introVideoLengthInSec
      introVideoLengthInTotalSeconds
      introVideoThumbnail
  }
}`

export const Get_Expert_Video = gql`
query mdLanguages {
  mdLanguages {
      id
      code
      name
  }
}`

export const Get_Expert_Video_By_Id = gql`
query getUserAllContributions ($userId: Int, $pagingCriteria: PagingCriteria) {
  getUserAllContributions (userId: $userId, pagingCriteria: $pagingCriteria) {
      data {
          id
          code
          title
          description
          vimeoId
          vimeoThumbnailUrl
          videoLengthMins
          videoLengthSecs
          viewsCount
          likesCount
          sharesCount
          dislikesCount
          language
          commentsCount
          fourmatCategory
          subtaskName
          taskName
          activityName
          createdAt
          commitmentNeeded
          contentTags
          originalContent
          languageId
          subtaskId
          taskId
          activityId
          relatedKiis {
            id
            name
          }
          keyPoints {
            id
            contentId
            keyPoint
        }
          quizDetails {
           id
           contentId
           question
          answer{
           id
           isanswer
           optionsAnswer
      }
      answerCount
      status
    }
      }
      pageMeta {
          nextPage
          previousPage
          hasNextPage
          hasPreviousPage
          totalCount
      }
  }
}`

export const Add_Video_Content = gql`
mutation addVideoContent ($videosList: [AddVideo!]!) {
  addVideoContent (videosList: $videosList) {
      success
      message
      data {
          id
          code
          title
          description
          vimeoId
          vimeoThumbnailUrl
          videoLengthMins
          videoLengthSecs
          viewsCount
          likesCount
          sharesCount
          dislikesCount
          language
          commentsCount
          fourmatCategory
          subtaskName
          taskName
          activityName
          createdAt
          commitmentNeeded
          contentTags
          relatedKiis {
            id
            name
          }
      }
  }
}`

export const Delete_All_Video_Content = gql`
mutation deleteContent ($contentId: Int!) {
  deleteContent(contentId: $contentId) {
    success
    message
    data
  }
}`

export const Update_Video_Content_By_Id = gql`
mutation UpdateVideoContent($videoDetails: AddVideo!){
  updateVideoContent(
    videoDetails: $videoDetails
  ) {
    success
    message
    data {
      id
      code
      title
      description
      vimeoId
      vimeoThumbnailUrl
      videoLengthMins
      videoLengthSecs
      viewsCount
      likesCount
      sharesCount
      dislikesCount
      savedCount
      language
      commentsCount
      fourmatCategory
      subtaskName
      taskName
      activityName
      createdAt
      commitmentNeeded
      contentTags
      originalContent
    }
  }
}`

export const Get_Content_In_Other_Langauages = gql`
query getContentInOtherLangauages($contentId: Int!) {
  getContentInOtherLangauages(contentId: $contentId) {
    id
    code
    title
    description
    vimeoId
    vimeoThumbnailUrl
    videoLengthMins
    videoLengthSecs
    viewsCount
    likesCount
    sharesCount
    dislikesCount
    savedCount
    language
    languageId
    createdBy {
      id
      name
      designation
      title
      role
      ppm
      profilePicture
      videosCount
      videoLikesCount
      videoViewsCount
      phoneNumber
      email
      introVideoId
      followers
      location
      pointsBadges
      coins
      employeeId
      gender
      dateOfJoining
      branch
      status
    }
    userWatchStatus {
      likeStatus
      wishlisted
      watchedAt
      durationSeconds
      playedSeconds
      wishlistedAt
      watchedThisMonth
    }
    commentsCount
    fourmatCategory
    subtaskId
    taskId
    activityId
    subtaskName
    taskName
    activityName
    createdAt
    commitmentNeeded
    keyPoints {
      id
      contentId
      keyPoint
    }
    contentTags
    originalContent
    relatedKiis {
      id
      name
    }
    quizDetails {
      id
      contentId
      question
      answerCount
      status
    }
  }
}`

export const Add_Update_Activity_Category = gql`
mutation addUpdateActivityCategory(
    $activityCategory: String!,
    $jobroleId: Int!,
    $activityCategoryId: Int
  ) {
  addUpdateActivityCategory(
    activityCategory: $activityCategory,
    jobroleId: $jobroleId,
    activityCategoryId: $activityCategoryId
  ) {
    success
    message
    data {
      id
      categoryName
    }
  }
}`

export const Delete_Activity_Category = gql`
mutation deleteActivityCategory($activityCategoryId: Int!) {
  deleteActivityCategory(activityCategoryId: $activityCategoryId) {
    success
    message
    data
  }
}`

export const Get_Activity_Category = gql`
query getAllActivityCategories($jobroleId: Int!) {
  getAllActivityCategories(jobroleId: $jobroleId) {
    id
    categoryName
  }
}`



export const Get_All_Activities_For_Category = gql`
query getAllActivitiesForACategory($activityCategoryId: Int!){
  getAllActivitiesForACategory(activityCategoryId: $activityCategoryId) {
    id
    activityName
  }
}`


export const Add_Update_Activity_For_Category = gql`
mutation addUpdateActivityForACategory(
  $activityName: String!
  $activityCategoryId: Int!
  $activityId: Int
) {
  addUpdateActivityForACategory(
    activityName: $activityName,
    activityCategoryId: $activityCategoryId,
    activityId: $activityId
  ) {
    success
    message
    data {
      id
      activityName
    }
  }
}`


export const Delete_Activity_For_Category = gql`
mutation deleteLdmsActivity($activityId: Int!) {
  deleteLdmsActivity(activityId: $activityId) {
    success
    message
    data
  }
}`


export const Get_All_Stage_Categories = gql`
query getAllStageCategories($jobroleId: Int!){
  getAllStageCategories(jobroleId: $jobroleId) {
    id
    categoryName
  }
}`

export const Add_Update_Stage_Category = gql`
mutation addUpdateStageCategory ($jobroleId: Int!, $stageCategory: String!, $stageCategoryId: Int) {
  addUpdateStageCategory(
    jobroleId: $jobroleId,
    stageCategory: $stageCategory,
    stageCategoryId: $stageCategoryId
  ) {
    success
    message
    data {
      id
      categoryName
    }
  }
}`

export const Delete_Stage_Category = gql`
mutation deleteStageCategory($stageCategoryId: Int!) {
  deleteStageCategory(stageCategoryId: $stageCategoryId) {
    success
    message
    data
  }
}`

export const Get_All_Stages_For_Category = gql`
query getAllStagesForCategory($categoryId: Int!)
{
  getAllStagesForCategory(categoryId: $categoryId) {
    id
    stageName
  }
}`

export const Add_Update_Stage_For_Category = gql`
mutation addUpdateStage(
  $stageCategoryId: Int!
  $stageName: String!
  $stageId: Int
) {
  addUpdateStage(stageCategoryId: $stageCategoryId, stageName: $stageName, stageId: $stageId) {
    success
    message
    data {
      id
      stageName
    }
  }
}`

export const Delete_Stage = gql`
mutation deleteStage($stageId: Int!) {
  deleteStage(stageId: $stageId) {
    success
    message
    data
  }
}`


export const Get_All_Status_For_Jobrole = gql`
query getAllStatusForJobrole($jobroleId: Int!)
{
  getAllStatusForJobrole(jobroleId: $jobroleId) {
    id
    statusName
  }
}`


export const Add_Update_Status_For_Jobrole = gql`
mutation addUpdateStatus($jobroleId: Int!, $statusName: String!, $statusId: Int) {
  addUpdateStatus(jobroleId: $jobroleId, statusName: $statusName, statusId: $statusId) {
    success
    message
    data {
      id
      statusName
    }
  }
}`

export const Delete_Status = gql`
mutation deleteStatus($statusId: Int!) {
  deleteStatus(statusId: $statusId) {
    success
    message
    data
  }
}`

export const Get_User_Last_Active_Status = gql`
query getUserLastActiveStatus($userId: Int!) {
  getUserLastActiveStatus(userId: $userId)
}`


export const Get_KiiValuesFormDateToDate = gql`
query getKiiValuesFormDateToDate( $accountId: Int!, $jobroleId: Int!, $userId: Int!, $startDate: Date!, $endDate: Date!) {
  getKiiValuesFormDateToDate(accountId: $accountId, jobroleId: $jobroleId, userId: $userId, startDate: $startDate, endDate: $endDate) {
    kiiName
    value {
      userId
      min
      max
      avg
      totalValue
      totalTarget
    }
  }
}`

export const Get_Attendance_Details_For_A_Time_Period = gql`
query getAttendanceDetailsForATimePeriod($userId: Int!, $startDate: Date!, $endDate: Date!) {
  getAttendanceDetailsForATimePeriod(userId: $userId, startDate: $startDate, endDate: $endDate) {
   signIn
    signOutForTheDay
    onLeave
  }
}`


export const Get_User_Performance_Data_For_Months = gql`
query getUserPerformanceDataForMonths($userId: Int!, $fromMonth: DateTime!, $toMonth: DateTime!) {
  getUserPerformanceDataForMonths(userId: $userId, fromMonth: $fromMonth, toMonth: $toMonth) {
    userId
    performance
    performanceMonth
    performanceMetric
    performanceLabel
  }
}`


export const ADD_JOBROLE_METRIC_THRESHOLDS = gql`
  mutation AddJobroleMetricThresholds($thresholds: JobroleThreshold!) {
    addJobroleMetricThresholds(thresholds: $thresholds) {
      success
      message
      data {
        jobroleId
        metricType
        levelValues {
          level
          rangeMin
          rangeMax
        }
      }
    }
  }
`;

export const GET_JOBROLE_METRIC_THRESHOLDS = gql`
  query GetJobroleMetricThresholds($jobroleId: Int!, $metricType: String!) {
    getJobroleMetricThresholds(jobroleId: $jobroleId, metricType: $metricType) {
      jobroleId
      metricType
      levelValues {
        level
        rangeMin
        rangeMax
      }
    }
  }
`;

export const Get_User_Users_In_Excel_For_Role = gql`
query getUserUsersInExcelForRole($roleId: Int!) {
  getUserUsersInExcelForRole(roleId: $roleId)
}`


export const CREATE_NEW_WEB_NOTIFICATION = gql`
  mutation createNewWebNotification($data: [Bulknotifications!]!) {
    createNewWebNotification(data: $data) {
      success
      message
      data {
        id
        title
        description
        notificationRead
        targetUserId
        createdAt
        eventType
        eventRefId
        extra
      }
    }
  }
`;



export const GET_USER_NOTIFICATIONS = gql`
  query getUserNotifications($userId: Int!, $pagingCriteria: PagingCriteria) {
    getUserNotifications(userId: $userId, pagingCriteria: $pagingCriteria) {
      data {
        id
        title
        description
        notificationRead
        targetUserId
        createdAt
        eventType
        eventRefId
        extra
         eventInitiator{
                id
                name
                surname
            }
      }
      pageMeta {
        nextPage
        previousPage
        hasNextPage
        hasPreviousPage
        totalCount
      }
    }
  }
`;


export const UPDATE_PROFILE_PIC = gql`
  mutation updateProfilePic($document: Upload!, $userId: Int, $reasonChanged: String) {
    updateProfilePic(document: $document, userId: $userId, reasonChanged: $reasonChanged) {
      success
      message
      data {
        id
        name
        profilePicture
        designation
        employeeId
        title
        role
        roleId
        ppm
        gender
        userCharacter
        surname
        dateOfBirth
        email
        phoneNumber
        designationId
        location
        profileActivated
        isExpert
        joiningDate
        roleStartDate
        reportingDate
        genderId
        address
        accountId
        accountName
        pointsBadges
        coins
        clanNeeded
        syncNeeded
        dartsNeeded
        mandatoryProjectTime
        dartsFormNeeded
        ldmsNeeded
        numberOfAssociates
        numberOfManagers
        userContentAgreement
        employeeType
        employeeTypeId
        branch
        city
        cityName
        state
        stateName
        zone
        status
        higestEducationQualification
        previousEmployer
        previousExperience
        password
      }
    }
  }
`;

export const REMOVE_PROFILE_PIC = gql`
  mutation removeProfilePic($userId: Int!) {
    removeProfilePic(userId: $userId) {
      success
      message
      data {
        id
        name
        profilePicture
        designation
        employeeId
        title
        role
        roleId
        ppm
        gender
        userCharacter
        surname
        dateOfBirth
        email
        phoneNumber
        designationId
        location
        profileActivated
        isExpert
        joiningDate
        roleStartDate
        reportingDate
        genderId
        address
        accountId
        accountName
        pointsBadges
        coins
        clanNeeded
        syncNeeded
        dartsNeeded
        mandatoryProjectTime
        dartsFormNeeded
        ldmsNeeded
        numberOfAssociates
        numberOfManagers
        userContentAgreement
        employeeType
        employeeTypeId
        branch
        city
        cityName
        state
        stateName
        zone
        status
        higestEducationQualification
        previousEmployer
        previousExperience
        password
      }
    }
  }
`;

export const GET_ATTENDANCE_DETAILS = gql`
  query GetAttendanceDetailsForATimePeriod($userId: Int!, $startDate: Date!, $endDate: Date!) {
    getAttendanceDetailsForATimePeriod(userId: $userId, startDate: $startDate, endDate: $endDate) {
      didSignIn
      didInput
      inputDate
      userId
      isHoliday
      isLeave
      isWeekoff
      givenTimeDistribution
      didSignOut
    }
  }
`;


export const Get_User_Value_For_Project_Time = gql`
query getUserValueForProjectTimeForATimePeriod($startDate: DateTime!, $endDate: DateTime!, $userId: Int!){
  getUserValueForProjectTimeForATimePeriod(
    startDate: $startDate,
    endDate: $endDate,
    userId: $userId
  ) {
    id
    projectName
    projectNorm
    depends
    userValue
    status
  }
}`;



export const Get_User_Types = gql`
query getUserTypes {
  getUserTypes {
    id
    userType
  }
}`;


export const GET_COHORT_FILTER_OPTIONS = gql`
query getCohortFilterOptions(
  $roleId: Int!
  $accountId: Int!
  $stateId: Int
  $cityId: Int
  $designationId: Int
  $userTypeId: Int
) {
  getCohortFilterOptions(
    roleId: $roleId
    accountId: $accountId
    stateId: $stateId
    cityId: $cityId
    designationId: $designationId
    userTypeId: $userTypeId
  ) {
    states {
      id
      stateName
    }
    cities {
      id
      cityName
    }
    designations {
      id
      designation
    }
    userTypes {
      id
      userType
    }
  }
}`;

export const GET_ADMIN_USERS_FOR_ROLES = gql`
  query getAdminUsersForRoles(
    $roleName: String
    $searchString: String
    $pagingCriteria: PagingCriteria
  ) {
    getAdminUsersForRoles(
      roleName: $roleName
      searchString: $searchString
      pagingCriteria: $pagingCriteria
    ) {
      data {
        id
        firstName
        surname
        email
        contactNumber
        profilePicture
        userType
        userStatus
        roleName
        roleId
        password
      }
      pageMeta {
        nextPage
        previousPage
        hasNextPage
        hasPreviousPage
        totalCount
      }
    }
  }
`;



export const GET_USERS_ASSIGNED_TO_ACCOUNT = gql`
query getUsersAssignedToAccount($accountId: Int!){
  getUsersAssignedToAccount(accountId: $accountId) {
    id
    name
  }
}`


export const GET_ROLE_SPECIFIC_USERS_FOR_ROLE = gql`
query getRoleSpecificUsersForRole($roleName: String!, $jobroleId: Int!) {
  getRoleSpecificUsersForRole(roleName: $roleName, jobroleId: $jobroleId) {
    id
    name
  }
}`;


export const GET_VIDEOS_WITH_FILTERS = gql`
  query getVideosForJobroleAndWithFilters(
    $jobroleId: Int!
    $pagingCriteria: PagingCriteria!
    $forUserId: Int
    $searchText: String
    $activityId: Int
    $taskId: Int
    $subtaskId: Int
    $creatorId: Int
    $languageId: Int
    $stateId: Int
    $cityId: Int
  ) {
    getVideosForJobroleAndWithFilters(
      jobroleId: $jobroleId
      pagingCriteria: $pagingCriteria
      forUserId: $forUserId
      searchText: $searchText
      activityId: $activityId
      taskId: $taskId
      subtaskId: $subtaskId
      creatorId: $creatorId
      languageId: $languageId
      stateId: $stateId
      cityId: $cityId
    ) {
      data {
        id
        code
        title
        description
        vimeoId
        vimeoThumbnailUrl
        videoLengthMins
        videoLengthSecs
        viewsCount
        likesCount
        sharesCount
        dislikesCount
        savedCount
        language
        languageId
        commentsCount
        fourmatCategory
        subtaskId
        taskId
        activityId
        subtaskName
        taskName
        activityName
        createdAt
        commitmentNeeded
        contentTags
        originalContent
      }
      pageMeta {
        nextPage
        previousPage
        hasNextPage
        hasPreviousPage
        totalCount
      }
    }
  }
`;

export const ASSIGN_USER = gql`
  mutation AssignUser($userAssignInfo: [AssignUnassignUser!]!) {
    assignUser(userAssignInfo: $userAssignInfo) {
      success
      message
      data
    }
  }
`;

export const GET_CAMPAIGN_LIST = gql`
  query getCampaignList(
    $jobroleId: Int!
    $fromDate: DateTime
    $toDate: DateTime
    $createdBy: Int
    $cohortId: Int
  ) {
    getCampaignList(
      jobroleId: $jobroleId
      fromDate: $fromDate
      toDate: $toDate
      createdBy: $createdBy
      cohortId: $cohortId
    ) {
      id
      cohort {
        id
        cohortName
        description
        filters
        accountId
        jobroleId
      }
      template {
        id
        title
        description
      }
      createdAt
      createdBy {
        id
        name
        profilePicture
        designation
        employeeId
        title
        role
        roleId
        ppm
        gender
        userCharacter
      }
    }
  }
`;

export const SEND_ANALYSIS_MESSAGE_TO_USER_AND_MANAGER = gql`
  mutation sendAnalysisMessageToUserAndManager(
    $userId: Int
    $managerId: Int
  ) {
    sendAnalysisMessageToUserAndManager(userId: $userId, managerId: $managerId) {
      success
      message
      data
    }
  }
`;

export const GET_CLAN_CREW_DASHBOARD_VALUES = gql`
  {
    getClanCrewDashboardValues {
      totalClients
      totalRoles
      totalUsers
      totalNotifications
    }
  }
`;

export const GET_MANAGERS_FOR_ROLE = gql`
  query GetManagersForRole($roleId: Int!, $searchTerm: String!, $pagingCriteria: PagingCriteria!) {
    getManagersForRole(roleId: $roleId, searchTerm: $searchTerm, pagingCriteria: $pagingCriteria) {
      data {
        id
        name
        employeeId
        email
        designation
        role
        roleId
      }
      pageMeta {
        nextPage
        previousPage
        hasNextPage
        hasPreviousPage
        totalCount
      }
    }
  }
`;

export const GET_SUPER_MANAGERS_FOR_ROLE = gql`
  query GetSuperManagersForRole($roleId: Int!, $searchTerm: String!, $pagingCriteria: PagingCriteria!) {
    getSuperManagersForRole(roleId: $roleId, searchTerm: $searchTerm, pagingCriteria: $pagingCriteria) {
      data {
        id
        name
        employeeId
        email
        designation
        role
        roleId
      }
      pageMeta {
        nextPage
        previousPage
        hasNextPage
        hasPreviousPage
        totalCount
      }
    }
  }
`;


export const ADD_UPDATE_STAGE = gql`
  mutation addUpdateStage(
    $jobroleId: Int!
    $stageCategoryId: Int!
    $stageName: String!
    $stageId: Int
    $colorCode: String
  ) {
    addUpdateStage(
      jobroleId: $jobroleId
      stageCategoryId: $stageCategoryId
      stageName: $stageName
      stageId: $stageId
      colorCode: $colorCode
    ) {
      success
      message
      data {
        id
        stageName
        stageColor
      }
    }
  }
`;

export const DELETE_STAGE = gql`
  mutation deleteStage($stageId: Int!) {
    deleteStage(stageId: $stageId) {
      success
      message
      data
    }
  }
`;

export const REORDER_STAGES = gql`
  mutation reorderStages($jobroleId: Int!, $reorderIds: [Int!]!) {
    reorderStages(jobroleId: $jobroleId, reorderIds: $reorderIds) {
      success
      message
      data {
        id
        stageName
        stageColor
      }
    }
  }
`;

export const GET_ALL_STAGES_FOR_JOBROLE = gql`
  query getAllStagesForJobrole($jobroleId: Int) {
    getAllStagesForJobrole(jobroleId: $jobroleId) {
      id
      stageName
      stageColor
    }
  }
`;

export const GET_ALL_STATUS_FOR_JOBROLE = gql`
  query GetAllStatusForJobrole($jobroleId: Int!) {
    getAllStatusForJobrole(jobroleId: $jobroleId) {
      id
      statusName
      statusColor
    }
  }
`;

export const ADD_UPDATE_STATUS = gql`
mutation AddUpdateStatus(
  $jobroleId: Int!
  $statusName: String!
  $statusId: Int
  $colorCode: String
) {
  addUpdateStatus(
    jobroleId: $jobroleId
    statusName: $statusName
    statusId: $statusId
    colorCode: $colorCode
  ) {
    success
    message
    data {
      id
      statusName
      statusColor
    }
  }
}`;

export const DELETE_STATUS = gql`
mutation DeleteStatus($statusId: Int!) {
  deleteStatus(statusId: $statusId) {
    success
    message
    data
  }
}`;


export const REORDER_STATUSES = gql`
mutation reorderStatus($jobroleId: Int!, $reorderIds: [Int!]!) {
  reorderStatus(jobroleId: $jobroleId, reorderIds: $reorderIds) {
    success
    message
    data {
      id
      statusName
      statusColor
    }
  }
}`;

export const GET_ALL_ACTIVITIES = gql`
query GetAllActivities($jobroleId: Int!) {
  getAllActivities(jobroleId: $jobroleId) {
    id
    activityName
    activityMethod
    status
    activityStatus {
      id
      statusName
    }
  }
}`;

export const UPDATE_ACTIVITY_TOGGLE = gql`
  mutation UpdateActivityToggle($jobroleId: Int!, $activityId: Int!, $newActivityStatus: Int!) {
    updateActivityToggle(jobroleId: $jobroleId, activityId: $activityId, newActivityStatus: $newActivityStatus) {
      success
      message
      data
    }
  }
`;

// Define new GraphQL mutations
export const DELETE_ACTIVITY_STATUS = gql`
  mutation DeleteActivityStatus($activityStatusId: Int!) {
    deleteActivityStatus(activityStatusId: $activityStatusId) {
      success
      message
      data
    }
  }
`;

export const ADD_UPDATE_ACTIVITY_STATUS = gql`
  mutation AddUpdateActivityStatus($activityId: Int!, $activityStatusName: String!, $activityStatusId: Int) {
    addUpdateActivityStatus(
      activityId: $activityId
      activityStatusName: $activityStatusName
      activityStatusId: $activityStatusId
    ) {
      success
      message
      data {
        id
        statusName
      }
    }
  }
`;

export const REORDER_ACTIVITY_STATUSES = gql`
  mutation ReorderActivityStatuses($activityId: Int!, $reorderIds: [Int!]!) {
    reorderActivityStatuses(activityId: $activityId, reorderIds: $reorderIds) {
      success
      message
      data {
        id
        statusName
      }
    }
  }
`;


export const GET_ROLE_DETAILS = gql`
  query GetJobrole($jobroleId: Int!) {
    getJobrole(jobroleId: $jobroleId) {
      id
      name
      targetEditDays
      inputEditDays
      pocEmail
      pocName
      pocContactNumber
      clanNeeded
      syncNeeded
      dartsNeeded
      dartsFormNeeded
      ldmsNeeded
      numberLogin
      emailLogin
      geoTracking
      mandatoryTimeDistribution
      mirrorNeeded
      signInSignOutRequired
      locationRequired
      account {
        id
        name
      }
    }
  }
`;


export const GET_PERFORMANCE_DATA_EXCEL = gql`
  query getPerformanceDataExcel($accountId: Int!, $jobroleId: Int!) {
    getPerformanceDataExcel(accountId: $accountId, jobroleId: $jobroleId)
  }
`;

export const UPLOAD_PERFORMANCE_EXCEL = gql`
  mutation uploadPerformanceExcel($document: Upload!, $accountId: Int!, $roleId: Int!) {
    uploadPerformanceExcel(file: $document, accountId: $accountId, roleId: $roleId) {
      success
      data
      message
      __typename
    }
  }
`;

export const GET_COMPANY_PRODUCTS = gql`
  query GetCompanyProducts(
    $accountId: Int!
    $jobroleId: Int
    $pagingCriteria: PagingCriteria!
    $productStatus: String
  ) {
    getCompanyProducts(
      accountId: $accountId
      jobroleId: $jobroleId
      pagingCriteria: $pagingCriteria
      productStatus: $productStatus
    ) {
      data {
        id
        accountId
        roleId
        productName
        title
        shortDescription
        description
        contentId
        publishDate
        expiryDate
        productStatus
        productVideo {
          id
          code
          title
          description
          languageId
          videoLengthMins
          videoLengthSecs
        }
      }
      pageMeta {
        nextPage
        previousPage
        hasNextPage
        hasPreviousPage
        totalCount
      }
    }
  }
`;

export const ADD_UPDATE_COMPANY_PRODUCT = gql`
  mutation addUpdateCompanyProduct($input: CompanyProductInput!) {
    addUpdateCompanyProduct(input: $input) {
    success
    message
    data{
      id
      accountId
      roleId
      productName
      title
      shortDescription
      description
      contentId
      publishDate
      expiryDate
      productStatus
      }
    }
  }
`;

export const DELETE_COMPANY_PRODUCT = gql`
  mutation DeleteCompanyProduct($productId: Int!) {
    deleteProducts(productId: $productId) {
      success
      message
      data {
        id
        accountId
        roleId
        productName
        title
        shortDescription
        description
        contentId
        publishDate
        expiryDate
        productStatus
      }
    }
  }
`;

export const GET_PRODUCT_COUNTS = gql`
  query GetCountOfProducts($accountId: Int!, $jobrole: Int) {
    getCountOfProducts(accountId: $accountId, jobrole: $jobrole) {
      productStatus
      count
    }
  }
`;


export const GET_User_Details_User_Management_For_ClanCrew = gql`
    query getUsersForAccount_ ($roleId: Int!, $filterByName: String, $joiningDateFilter:DateTime, $pagingCriteria: PagingCriteria, $filters: [JSON!], $reportingIds: [Int!]) {
      getUsersForAccount (roleId: $roleId, filterByName: $filterByName, joiningDateFilter:$joiningDateFilter, pagingCriteria: $pagingCriteria, filters: $filters, reportingIds: $reportingIds) {
        data {
               id
               surname
        name
        fullname
        debug
        designation
        employeeId
        employeeId
        cityName
        email
        phoneNumber
        profileActivated
        userType {
             id
            userType
       }
        joiningDate
        accountId
        branch
          }
          pageMeta {
              nextPage
              previousPage
              hasNextPage
              hasPreviousPage
              totalCount
          }
      }
  }`;

export const GET_ACCOUNT_SUMMARY = gql`
  query getAccountSummary(
    $accountId: Int
    $jobroleId: Int
  ) {
    getAccountSummary(
      accountId: $accountId
      jobroleId: $jobroleId
    )
  }
`;

export const GET_LOCATION_SUMMARY = gql`
  query getLocationSummary(
    $accountId: Int
    $jobroleId: Int
    $zone: String
    $stateId: Int
    $cityId: Int
  ) {
    getLocationSummary(
      accountId: $accountId
      jobroleId: $jobroleId
      zone: $zone
      stateId: $stateId
      cityId: $cityId
    )
  }
`;

export const GET_EXPORT_ACCOUNT_SUMMARY = gql`
  query GetExportAccountSummary($accountId: Int, $jobroleId: Int) {
    getExportAccountSummary(accountId: $accountId, jobroleId: $jobroleId)
  }
`;

export const GET_USER_BEHAVIOURAL_INSIGHTS = gql`
  query GetQuestionsAnsweredForUser($userId: Int!) {
    getQuestionsAnsweredForUser(userId: $userId) {
      ... on OnboardingQuestion {
        id
        question
        options {
          id
          optionText
          whatItConveys
          recommendedActionToManager
        }
        responce {
          optionId
        }
      }
      ... on UserPersonaQuestion {
        id
        question
        answers {
          id
          answerText
          whatItConveys
          recommendedActionToManager
        }
        responses {
          id
          answerId
        }
      }
    }
  }
`;

export const GET_LIST_OF_COHORTS = gql`
  query getListOfCohorts($accountId: Int, $jobroleId: Int) {
    getListOfCohorts(accountId: $accountId, jobroleId: $jobroleId) {
      id
      cohortName
      description
      filters
      accountId
      jobroleId
    }
  }
`;

export const CREATE_COHORT = gql`
  mutation createCohort(
    $filters: JSON!
    $cohortName: String!
    $cohortDescription: String
    $accountId: Int
    $jobroleId: Int
  ) {
    createCohort(
      filters: $filters
      cohortName: $cohortName
      cohortDescription: $cohortDescription
      accountId: $accountId
      jobroleId: $jobroleId
    ) {
      success
      message
      data {
        id
        cohortName
        description
        filters
        accountId
        jobroleId
      }
    }
  }
`;

export const CREATE_WEB_BULK_CAMPAIGN = gql`
  mutation createWebBulkCampaign(
    $cohortId: Int!
    $title: String!
    $description: String!
  ) {
    createWebBulkCampaign(
      data: { cohortId: $cohortId, title: $title, description: $description }
    ) {
      success
      message
      data
    }
  }
`;

export const GET_ALL_USER_PERSONA_QUESTIONS = gql`
  query GetAllUserPersonaQuestions($searchTerm: String) {
    getAllUserPersonaQuestions(searchTerm: $searchTerm) {
      id
      question
    }
  }
`;

export const ADD_COHORT_QUESTIONS_ASSIGNMENT = gql`
  mutation AddCohortQuestionsAssignemnt(
    $cohortId: Int!
    $questionIds: [Int!]!
    $assignemntDate: Date!
    $unselectedUserIds: [Int!]
  ) {
    addCohortQuestionsAssignemnt(
      cohortId: $cohortId
      questionIds: $questionIds
      assignemntDate: $assignemntDate
      unselectedUserIds: $unselectedUserIds
    ) {
      success
      message
      data
    }
  }
`;

export const GET_SUBTASK_TAGGING = gql`
  query GetSubtaskTagging($subtaskId: Int!) {
    getSubtaskTagging(subtaskId: $subtaskId) {
      subtaskId
      leadIndicators {
        id
        name
        colorValue
        taggedAt
        taggedBy
      }
      videos {
        id
        title
        vimeoId
        vimeoThumbnailUrl
        taggedAt
        taggedBy
      }
    }
  }
`;

export const GET_SUBTASK_KII_RELATION = gql`
  query getSubtaskKiiRelation($subtaskId: Int!) {
    getSubtaskKiiRelation(subtaskId: $subtaskId) {
      id
      kiiId
      subtaskId
      createdBy {
        name
      }
      kiiName
      createdAt
      modifiedBy
      modifiedAt
      status
    }
  }
`;

export const SAVE_SUBTASK_TAGGING = gql`
  mutation SaveSubtaskTagging(
    $subtaskId: Int!
    $leadIndicatorIds: [Int!]
    $videoIds: [Int!]
  ) {
    saveSubtaskTagging(
      subtaskId: $subtaskId
      leadIndicatorIds: $leadIndicatorIds
      videoIds: $videoIds
    ) {
      success
      message
      data {
        subtaskId
        leadIndicatorCount
        videoCount
        updatedAt
        updatedBy
      }
    }
  }
`;

export const GET_SUBTASK_TAGGING_AUDIT = gql`
  query GetSubtaskTaggingAudit($subtaskId: Int!) {
    getSubtaskTaggingAudit(subtaskId: $subtaskId) {
      id
      action
      itemType
      itemName
      performedBy
      performedAt
    }
  }
`;

export const GET_SUBTASK_RELATION_EVENTS = gql`
  query getSubtaskRelationEvents($subtaskId: Int!, $pagingCriteria: PagingCriteriaWithSkipTop) {
    getSubtaskRelationEvents(subtaskId: $subtaskId, pagingCriteria: $pagingCriteria) {
      data {
        id
        subtaskId
        kiiId
        createdAt
        createdBy {
          name
        }
        kiiName
        actionType
      }
      pageMeta {
        totalCount
        totalPages
        currentPage
        limit
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const ADD_UPDATE_KII_SUBTASK = gql`
  mutation addUpdateKiiSubtask($subtaskId: Int!, $kiiId: Int!, $removeRelation: Boolean!) {
    addUpdateKiiSubtask(subtaskId: $subtaskId, kiiId: $kiiId, removeRelation: $removeRelation) {
      success
      message
      data {
        id
        kiiId
        subtaskId
        createdAt
        modifiedBy
        modifiedAt
        status
      }
    }
  }
`;

// Get User Persona Campaigns for Question Analytics
export const Get_User_Persona_Campaigns = gql`
  query getUserPersonaCampaigns($accountId: Int!, $jobroleId: Int!, $pagingCriteria: PagingCriteriaWithSkipTop) {
    getUserPersonaCampaigns(accountId: $accountId, jobroleId: $jobroleId, pagingCriteria: $pagingCriteria) {
      data {
        id
        createdAt
        questionsCount
        cohort {
          cohortName
        }
        createdBy {
          id
          name
        }
        targetedUsersCount
        answeredUsersCount
        partiallyAnsweredUsersCount
        noResponceUsersCount
      }
      pageMeta {
        totalCount
        totalPages
        currentPage
        limit
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const Get_User_Persona_Campaign_Details = gql`
  query getUserPersonaQuestionsCampignDetails($campaignId: Int!) {
    getUserPersonaQuestionsCampignDetails(campaignId: $campaignId) {
      id
      createdAt
      questionsCount
      cohort {
        id
        cohortName
      }
      questions {
        campaignId
        questionId
        question {
          question
        }
        targetedUsersCount
        answeredUsersCount
        noResponceUsersCount
      }
      targetedUsersCount
      answeredUsersCount
      noResponceUsersCount
    }
  }
`;

export const Get_User_Responses_For_Question = gql`
  query getUserResponcesForQuestionInCampaign($campaignId: Int!, $questionId: Int!, $pagingCriteria: PagingCriteriaWithSkipTop) {
    getUserResponcesForQuestionInCampaign(campaignId: $campaignId, questionId: $questionId, pagingCriteria: $pagingCriteria) {
      data {
        id
        pushedDate
        question {
          id
          answerType
          answers {
            id
            answerText
          }
          responses {
            userId
            answerId
            createdAt
          }
          question
        }
        user {
          id
          name
          surname
          profilePicture
          designation
          employeeId
          title
          role
          roleId
          ppm
          gender
          userCharacter
        }
      }
      pageMeta {
        totalCount
        totalPages
        currentPage
        limit
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const GET_CLAN_FAQ = gql`
  query getClanfaq($searchTerm: String, $pagingCriteria: PagingCriteria) {
    getClanfaq(searchTerm: $searchTerm, pagingCriteria: $pagingCriteria) {
      data {
        id
        lang
        faqtype
        faqParameter
        faqValue
        status
      }
      pageMeta {
        nextPage
        previousPage
        hasNextPage
        hasPreviousPage
        totalCount
      }
    }
  }
`;

export const GET_FAQS = gql`
  query getFaqs($accountId: Int, $roleId: Int, $searchTerm: String, $faqModule: String, $pagingCriteria: PagingCriteriaWithSkipTop) {
    getFaqs(
      accountId: $accountId
      roleId: $roleId
      searchTerm: $searchTerm
      faqModule: $faqModule
      pagingCriteria: $pagingCriteria
    ) {
      data {
        id
        lang
        accountId
        roleIds
        faqtype
        faqParameter
        faqValue
        status
      }
      pageMeta {
        totalCount
        totalPages
        currentPage
        limit
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const ADD_UPDATE_CLAN_FAQS = gql`
  mutation addUpdateClanFaqs(
    $accountId: Int
    $roleId: Int
    $faqValue: String!
    $faqParameter: String!
    $faqId: Int
    $status: Int
    $faqLabel: String!
  ) {
    addUpdateClanFaqs(
      accountId: $accountId
      roleId: $roleId
      faqValue: $faqValue
      faqParameter: $faqParameter
      faqId: $faqId
      faqLabel: $faqLabel
      status: $status
    ) {
      success
      message
      data {
        id
        lang
        accountId
        roleIds
        faqtype
        faqParameter
        faqValue
        status
      }
    }
  }
`;

export const Get_Form_Details = gql`
  query getFormDetails($roleId: Int!, $pagingCriteria: PagingCriteria) { 
    getFormDetails(roleId: $roleId, pagingCriteria: $pagingCriteria) {
      data {
        id
        formName
        requiredStarQuestions 
        duplicateCheckLevel
        duplicateCheckQuestionIds
      }
      pageMeta {
        nextPage
        previousPage
        hasNextPage
        hasPreviousPage
        totalCount
      }
    }
  }
`;


export const Add_Update_Form = gql`
  mutation addUpdateForm(
    $formName: String!
    $roleId: Int!
    $requiredStarQuestions: Int
    $duplicateCheckLevel: String
    $duplicateCheckQuestionIds: [Int!]
    $formId: Int
    $parentFormId: Int
  ) {
    addUpdateForm(
      formName: $formName
      roleId: $roleId
      requiredStarQuestions: $requiredStarQuestions
      duplicateCheckLevel: $duplicateCheckLevel
      duplicateCheckQuestionIds: $duplicateCheckQuestionIds
      formId: $formId
      parentFormId: $parentFormId
    ) {
      success
      message
      data {
        id
        formName
        requiredStarQuestions
        duplicateCheckLevel
        duplicateCheckQuestionIds
      }
    }
  }
`;

export const Delete_Complete_Form = gql`
  mutation deleteCompleteForm($roleId: Int!, $formId: Int!) {
    deleteCompleteForm(roleId: $roleId, formId: $formId) {
      success
      message
      data
    }
  }
`;

export const Delete_Question_Option_In_Form = gql`
  mutation deleteQuestionOptionInForm($questionId: Int!, $formId: Int!, $referenceId: Int) {
    deleteQuestionOptionInForm(questionId: $questionId, formId: $formId, referenceId: $referenceId) {
      success
      message
      data
    }
  }
`;

export const Get_Question_Types = gql`
  query getQuestionTypes {
    getQuestionTypes
  }
`;

export const Get_Answer_Types = gql`
  query getAnswerTypes {
    getAnswerTypes
  }
`;

export const Get_Only_Question_In_Form = gql`
  query getOnlyQuestionInForm($formId: Int!, $onlyStar: Boolean!) {
    getOnlyQuestionInForm(formId: $formId, onlyStar: $onlyStar) {
      id
      question
    }
  }
`;

export const Get_All_Form_Question_And_Options = gql`
  query getAllFormQuestionAndOptions($formId: Int!) {
    getAllFormQuestionAndOptions(formId: $formId) {
      id
      question
      qType
      aType
      formId
      hintText
      maxLines
      starQuestion
      referenceFormId
      toView
      reValidation
      reValidationText
      gqlQuery
      gqlPayload
      contributingToFormDate
      saveValue
      viewValue
      options {
        __typename
        ... on Option {
          id
          option
        }
        ... on Form {
          id
          name
        }
      }
    }
  }
`;

export const Add_Update_Question_Admin_Panel = gql`
  mutation addUpdateQuestionAdminPanel($data: QuestionUpdateInput!) {
    addUpdateQuestionAdminPanel(data: $data) {
      success
      message
    }
  }
`;

export const Get_Holidays = gql`
  query getHolidayReason($accountId: Int!) {
    getHolidayReason(accountId: $accountId) {
      id
      accountId
      exceptionDate
      isWorking
      reason
    }
  }
`;

export const Add_Update_Holidays = gql`
  mutation addUpdateHolidays($accountId: Int!, $id: Int, $exceptionDate: Date!, $reason: String!, $isWorkingDay: Boolean!) {
    addUpdateHolidays(accountId: $accountId, id: $id, exceptionDate: $exceptionDate, reason: $reason, isWorkingDay: $isWorkingDay) {
      success
      message
      data {
        accountId
        exceptionDate
        isWorking 
        reason
      }
    }
  }
`;


export const Delete_Holiday = gql`
  mutation deleteHoliday($holidayId: Int!, $accountId: Int!) {
    deleteHoliday(holidayId: $holidayId, accountId: $accountId) {
      success
      message
      data
    }
  }
`;

export const Export_Activities_Tasks_Subtask_Excel = gql`
  query exportActivitiesTasksSubtaskExcel($jobroleId: Int!) {
    exportActivitiesTasksSubtaskExcel(jobroleId: $jobroleId)
  }
`;

export const GET_SUPER_MANAGERS_WITH_EMPID_LOCATION_FULLNAME = gql`
  query getSuperManagersWithEmpidLocationFullname($roleId: Int!, $searchTerm: String!, $pagingCriteria: PagingCriteria!) {
    getSuperManagersWithEmpidLocationFullname(roleId: $roleId, searchTerm: $searchTerm, pagingCriteria: $pagingCriteria) {
      data {
        id
        name
        surname
        designation
        employeeId
        location
      }
      pageMeta {
        nextPage
        previousPage
        hasNextPage
        hasPreviousPage
        totalCount
      }
    }
  }
`;

export const GET_MANAGER_WITH_FULLNAME_EMPID_LOCATION = gql`
  query getManagerWithFullnameEmpidLocation($roleId: Int!, $searchTerm: String!, $pagingCriteria: PagingCriteria!) {
    getManagerWithFullnameEmpidLocation(roleId: $roleId, searchTerm: $searchTerm, pagingCriteria: $pagingCriteria) {
      data {
        id
        name
        surname
        designation
        employeeId
        location
      }
      pageMeta {
        nextPage
        previousPage
        hasNextPage
        hasPreviousPage
        totalCount
      }
    }
  }
`;

export const GET_NOT_EXPERT_EMPID_LOCATION_FULLNAME = gql`
  query getNotExpertEmpidLoctaionFullname($accountId: Int!, $searchTerm: String!) {
    getNotExpertEmpidLoctaionFullname(accountId: $accountId, searchTerm: $searchTerm) {
      id
      name
      surname
      designation
      employeeId
      location
    }
  }
`;

export const GET_ACCOUNT_EXPERTS_FULLNAME_EMPID_LOCATION = gql`
  query getAccountExpertsFullnameEmpidLocation($accountId: Int!, $searchTerm: String!, $pagingCriteria: PagingCriteria) {
    getAccountExpertsFullnameEmpidLocation(accountId: $accountId, searchTerm: $searchTerm, pagingCriteria: $pagingCriteria) {
      data {
        id
        name
        surname
        designation
        employeeId
        location
      }
      pageMeta {
        nextPage
        previousPage
        hasNextPage
        hasPreviousPage
        totalCount
      }
    }
  }
`;

export const Export_Filtered_Users_For_Cohort = gql`
  query exportFilteredUsersForCohort($accountId: Int!, $jobroleId: Int!, $cohortId: Int!) {
    exportFilteredUsersForCohort(accountId: $accountId, jobroleId: $jobroleId, cohortId: $cohortId)
  }
`;